import { useRouter } from 'next/dist/client/router'
import Head from 'next/head'
import React from 'react'

import { ChoiceList } from '../@engine/Choices'
import { Layout } from '../components/Layout'

export type Group =
  | 'Bank-Account'
  | 'Credit-Card'
  | 'Insurance'
  | 'Loan'
  | 'Robo-advisor'
  | 'Other'

export const groups: Group[] = [
  'Bank-Account',
  'Credit-Card',
  'Insurance',
  'Loan',
  'Robo-advisor',
  'Other',
]

export type Choices =
  | 'Bank-Account-Checking'
  | 'Bank-Account-Savings'
  | 'Credit-Card-Balance-Transfer'
  | 'Credit-Card-Secured'
  | 'Credit-Card-Rewards'
  | 'Credit-Card-Student'
  | 'Insurance-Car'
  | 'Insurance-Health'
  | 'Insurance-Homeowners'
  | 'Insurance-Life'
  | 'Insurance-Long-Term-Disability'
  | 'Insurance-Renters'
  | 'Loan-Auto'
  | 'Loan-Home'
  | 'Loan-Personal'
  | 'Loan-Student'
  | 'Other-Car-Buying'
  | 'Other-Home-Buying'
  | 'Other-Legal'
  | 'Other-Scholarships'
  | 'Other-Spending-Plans'
  | 'Other-Tax-Software'
  | 'Robo-Advisors'

const Recommendations = () => {
  const router = useRouter()
  const params = router.query
  const queryGroup = params.group as Group | undefined
  const queryChoice = params.choice as Choices | undefined

  const defaultGroup: Group = 'Bank-Account'
  const defaultChoice: Choices = 'Bank-Account-Checking'
  const [group, updateGroup] = React.useState(queryGroup || defaultGroup)
  const [choice, updateChoice] = React.useState(queryChoice || defaultChoice)

  React.useEffect(() => {
    if (queryGroup && queryChoice) {
      updateGroup(queryGroup)
      updateChoice(queryChoice)
    }
  }, [queryGroup, queryChoice])

  const choiceList = ChoiceList()

  return (
    <Layout>
      <Head>
        <title>Recommendations</title>
        <meta
          name="description"
          content="Check out our recommended products, such as credit cards and bank accounts, that make managing your finances a breeze!"
        />
      </Head>

      <div className="recommendations mb75 fcc">
        <div className="header">What are you looking for?</div>
        <div className="comp-disclosure">
          <strong>Heads up</strong>: Unlike many websites on the Internet, we
          are not compensated for any of our recommendations! And we{' '}
          <strong>never</strong> recommend a product we are unwilling to use
          ourselves. In fact, we personally use most of these!
        </div>
        <div className="groups fr">
          {groups.map((g) => (
            <button
              key={g}
              onClick={() => {
                updateGroup(g as Group)
                if (g === 'Bank-Account') {
                  updateChoice('Bank-Account-Checking')
                }
                if (g === 'Credit-Card') {
                  updateChoice('Credit-Card-Student')
                }
                if (g === 'Insurance') {
                  updateChoice('Insurance-Car')
                }
                if (g === 'Loan') {
                  updateChoice('Loan-Student')
                }
                if (g === 'Robo-advisor') {
                  updateChoice('Robo-Advisors')
                }
                if (g === 'Other') {
                  updateChoice('Other-Tax-Software')
                }
              }}
              className={`${g === group ? 'active' : ''} group`}
              type="button"
            >
              {g.replaceAll('-', ' ')}
            </button>
          ))}
        </div>
        <div className="divider" />
        <div className="choices fr">
          {Object.keys(choiceList)
            .filter((c) => c.includes(group))
            .map((c) => (
              <button
                key={c}
                onClick={() => updateChoice(c as Choices)}
                className={`${c === choice ? 'active' : ''} group`}
                type="button"
              >
                {c
                  .replace(group, '')
                  .replace('(', '')
                  .replace(')', '')
                  .replaceAll('-', ' ')}
              </button>
            ))}
        </div>
        {choiceList[choice]}
      </div>
    </Layout>
  )
}

export default Recommendations
